var webVitals = require("web-vitals/attribution");

// Chromium browser setting to reduce data usage
let saveData = ("connection" in navigator) ? navigator.connection.saveData : false;

// Check if page is using critical CSS
let criticalCss = document.documentElement.classList.contains("ws-critical-css");

// Push event to Google Tag Manager dataLayer with the determined user connection quality
function pushConnectionQualityGTMevent() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        "connectionQuality": document.documentElement.dataset.wsConnectionQuality
    });
}

// Given a DOM node, will return the full HTML path string
function getElementDOMpath(el) {
    if (el) {
        let stack = [];

        while (el.parentNode != null) {
            let sibCount = 0;
            let sibIndex = 0;

            for (let i = 0; i < el.parentNode.childNodes.length; i++) {
                let sib = el.parentNode.childNodes[i];

                if (sib.nodeName == el.nodeName) {
                    if (sib === el) {
                        sibIndex = sibCount;
                    }

                    sibCount++;
                }
            }

            if (typeof el.hasAttribute === "function" && el.hasAttribute("id") && el.id != "") {
                stack.unshift(el.nodeName.toLowerCase() + "#" + el.id);
            } else if (sibCount > 1) {
                stack.unshift(el.nodeName.toLowerCase() + ":eq(" + sibIndex + ")" + (el.classList.length == 0 ? "" : ".") + el.classList);
            } else {
                stack.unshift(el.nodeName.toLowerCase() + (el.classList.length == 0 ? "" : ".") + el.classList);
            }

            el = el.parentNode;
        }

        return stack.slice(2).join(" > "); // removes the html and body elements
    }

    return "";
}

// Send LCP score and attribution info to GTM
function pushLCPtoDataLayer(metric) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        "event": "lcp",
        "lcpScore": Math.round(metric.value),
        "lcpElement": getElementDOMpath(metric.attribution.lcpEntry.element),
        "saveData": saveData,
        "criticalCss": criticalCss,
        "navigationType": metric.navigationType
    });
}

// Send CLS score and attribution info to GTM
function pushCLStoDataLayer(metric) {
    // Get largest CLS entry element, if any
    let largestCLSsource = metric.attribution.largestShiftEntry.sources[0];
    let largestCLSelement = (largestCLSsource) ? largestCLSsource.node : null;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        "event": "cls",
        "clsScore": Math.round(metric.value * 1000), // Multiplying cls score by 1000 as google analytics events only handles whole numbers
        "clsElement": getElementDOMpath(largestCLSelement),
        "saveData": saveData,
        "criticalCss": criticalCss,
        "navigationType": metric.navigationType
    });
}

// Send FID score and attribution info to GTM
function pushFIDtoDataLayer(metric) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        "event": "fid",
        "fidScore": Math.round(metric.value),
        "fidElement": getElementDOMpath(metric.attribution.eventEntry.target),
        "saveData": saveData,
        "criticalCss": criticalCss,
        "navigationType": metric.navigationType
    });
}

// Send FCP score and attribution info to GTM
function pushFCPtoDataLayer(metric) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        "event": "fcp",
        "fcpScore": Math.round(metric.value),
        "saveData": saveData,
        "criticalCss": criticalCss,
        "navigationType": metric.navigationType
    });
}

// Send TTFB score and attribution info to GTM
function pushTTFBtoDataLayer(metric) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        "event": "ttfb",
        "ttfbScore": Math.round(metric.value),
        "saveData": saveData,
        "criticalCss": criticalCss,
        "navigationType": metric.navigationType
    });
}

// Send INP score and attribution info to GTM
function pushINPtoDataLayer(metric) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        "event": "inp",
        "inpScore": Math.round(metric.value),
        "inpElement": getElementDOMpath(metric.attribution.eventEntry.target),
        "saveData": saveData,
        "criticalCss": criticalCss,
        "navigationType": metric.navigationType
    });
}

webVitals.onLCP(pushLCPtoDataLayer);
webVitals.onCLS(pushCLStoDataLayer);
webVitals.onFID(pushFIDtoDataLayer);
webVitals.onFCP(pushFCPtoDataLayer);
webVitals.onTTFB(pushTTFBtoDataLayer);
webVitals.onINP(pushINPtoDataLayer);

pushConnectionQualityGTMevent();